/**
 * FRD Stores
 * mlx latitude: 33.991650, longitude: -117.907680
 */
let FRDStores = {
  /**
   * Ready
   */
  ready() {
    // If document is ready
    if(document.readyState === 'ready' || document.readyState === 'complete') {
      // Initialize
      FRDStores.initialize();
    }

    if(document.readyState !== 'ready' && document.readyState !== 'complete') {
      // Document is not ready, wait for ready state to change
      document.onreadystatechange = async function() {
        // If document is ready
        if(document.readyState == 'complete') {
          // Initialize
          await FRDStores.initialize();
        }
      }
    }
  },

  /**
   * Initialize
   */
  async initialize() {
    // Trigger required functions
    await FRDStores.create_elements();
    await FRDStores.header_anchors();
    FRDStores.dropdown_toggle();
    FRDStores.lightbox_toggle();

    // Geolocation
    FRDStores.geolocation_get_position();
  },

  /**
   * Creat elements
   */
  async create_elements() {
    const my_mho_store_id = localStorage.getItem('my_mho_store_id');
    const store = await FRDStores.get_store(my_mho_store_id);
    const frd_my_store_header = document.querySelector('div[frd-my-store-header]');

    // Create overlay
    const frd_my_store_overlay = document.createElement('div');

    // Set attribute
    frd_my_store_overlay.setAttribute('frd-stores-overlay', '');

    // Append overlay to body
    document.body.appendChild(frd_my_store_overlay);

    // Create lightbox
    const frd_my_store_lightbox = document.createElement('div');
    let frd_stores_lightbox_header = `
      <div frd-stores-lightbox-header>
        <span frd-stores-lightbox-title>Choose a store</span>
        <button type="button" frd-stores-lightbox-close>
          X
        </button>
        <form name="frd-stores-search" method="post" action="#">
          <fieldset>
            <label for="miles">Find a store within</label>
            <input name="miles" type="text" placeholder="10" required>
            <label for="postal-code">miles of postal code</label>
            <input name="postal-code" type="text" placeholder="90210" required>
            <button name="search" type="submit">
              Search
            </button>
          </fieldset>
        </form>
      </div>
      <div frd-stores-lightbox-content></div>
    `;

    // Set attribute
    frd_my_store_lightbox.setAttribute('frd-stores-lightbox', '');

    // Insert markup
    frd_my_store_lightbox.insertAdjacentHTML('afterbegin', frd_stores_lightbox_header);

    // Append lightbox to overlay
    frd_my_store_overlay.append(frd_my_store_lightbox);

    // If store does not exist
    if(!store) {
      //console.log('Missing "store" parameter.');

      return;
    }

    // Create dropdown
    const frd_my_store_dropdown = document.createElement('div');
    const store_component = FRDStores.store_component(store, 'header');

    // Set attribute
    frd_my_store_dropdown.setAttribute('frd-my-store-header-dropdown', '');

    // Insert markup
    frd_my_store_dropdown.insertAdjacentHTML('afterbegin', store_component);

    // Append dropdown
    frd_my_store_header.append(frd_my_store_dropdown);
  },

  /**
   * Store component
   */
  store_component(store = null, render_in = null, re_render = false) {
    // If store does not exist
    if(!store) {
      //('Missing "store" parameter.');

      return;
    }

    const my_mho_store_id = localStorage.getItem('my_mho_store_id');
    let store_inventory = '';
    let store_contact_subtitle = '';
    let store_phone_link = '';
    let store_email_link = '';
    let view_store_button = '';
    let view_store_button_header = '';
    let address_encoded = encodeURI(store.address.replaceAll('<br>', ' '));
    let get_directions_url = `https://www.google.com/maps/dir/?api=1&destination=${address_encoded}`;
    let view_all_stores_button = '';
    let store_distance = '';
    let set_store_button = '';

    // If store has inventory
    if(store.inventory >= 0) {
      // Add store inventory
      store_inventory = `
        <p class="inventory">
          ${store.inventory} in stock
        </p>
      `;
    }

    // If store has a phone or email
    if(store.phone || store.email) {
      // Add store contact subtitle
      store_contact_subtitle = `
        <span class="subtitle">
          Contact
        </span>
      `;
    }

    // If store has a phone
    if(store.phone) {
      // Add store phone link
      store_phone_link = `
        <a class="phone" href="tel:${store.phone}" title="Call store">
          ${store.phone}
        </a>
      `;
    }

    // If store has an email
    if(store.email) {
      // Add store email link
      store_email_link = `
        <a class="email" href="mailto:${store.email}" title="Email store">
          ${store.email}
        </a>
      `;
    }

    // If store has a URL and is rendered in header
    if(store.url && render_in === 'header') {
      // Create "view store" button
      view_store_button_header = `
        <a class="view-store" href="${store.url}" title="View store" target="_blank">
          View store
        </a>
      `;
    }

    // If store has distance
    if(store.distance !== undefined) {
      store_distance = `
        <span class="distance">
          ${store.distance.toFixed(2)} miles
        </span>
      `;
    }

    // Set store button attributes
    let set_store_button_class = '';
    let set_store_button_icon = '&#9734;';
    let set_store_button_text = 'Set as my store';

    // If looped store is user's store
    if(store.id == my_mho_store_id) {
      set_store_button_class = ' class="active" disabled aria-disabled="true"';
      set_store_button_icon = '&#9733;';
      set_store_button_text = 'My store';
    }

    // If render in lightbox
    if(render_in === 'lightbox') {
      set_store_button = `
        <button type="button" frd-set-store-id="${store.id}"${set_store_button_class}>
          <span class="icon-star">${set_store_button_icon}</span> ${set_store_button_text}
        </button>
      `;
    }

    // If store has a URL and is rendered in lightbox
    if(store.url && render_in === 'lightbox') {
      // Create "view store" button
      view_store_button = `
        <a class="view-store" href="${store.url}" title="View store" target="_blank">
          View store
        </a>
      `;
    }

    // If render in header
    if(render_in === 'header' && re_render === false) {
      view_all_stores_button = `
        <button type="button" frd-stores-lightbox>
          View all stores
        </button>
      `;
    }

    // Create markup
    const container_div_open = re_render === false ? '<div>' : '';
    const container_div_close = re_render === false ? '</div>' : '';
    const store_markup = `
      ${container_div_open}
        <span class="title">
          ${store.title}
        </span>
        ${store_inventory}
        <span class="subtitle">
          Address
        </span>
        <p class="address">
          ${store.address}
        </p>
        <a class="get-directions" href="${get_directions_url}" title="Get directions" target="_blank">
          Get directions
        </a>
        ${store_contact_subtitle}
        ${store_phone_link}
        ${store_email_link}
        ${view_store_button_header}
      ${container_div_close}
      ${container_div_open}
        ${store_distance}
        ${set_store_button}
        ${view_store_button}
        ${view_all_stores_button}
      ${container_div_close}
    `;

    return store_markup;
  },

  /**
   * Header anchors
   */
  async header_anchors() {
    const my_mho_store_id = localStorage.getItem('my_mho_store_id');
    const store = await FRDStores.get_store(my_mho_store_id);
    let button = document.querySelector('div[frd-my-store-header] button[frd-stores-lightbox]');

    // If store exists
    if(store) {
      // Remove button default attribute
      button.removeAttribute('frd-stores-lightbox');

      // Set button store ID attribute
      button.setAttribute('frd-my-store-id', store.title);

      // Update button text
      button.textContent =  my_mho_store_id;
    }
  },

  /**
 * Dropdown toggle
 */
  dropdown_toggle() {
    const frd_my_store_dropdown_anchor = document.querySelector('div[frd-my-store-header] button[frd-my-store-id]');

    // If frd_my_store_dropdown_anchor does not exist
    if(!frd_my_store_dropdown_anchor) {
      return;
    }

    // Dropdown anchor click listener
    frd_my_store_dropdown_anchor.addEventListener('click', (event) => {
      event.stopPropagation(); // Prevent immediate outside-click trigger
      let frd_my_store_dropdown = document.querySelector('div[frd-my-store-header-dropdown]');

      console.log('hi');

      // If dropdown does not exist
      if(!frd_my_store_dropdown) {
        return;
      }

      // If dropdown is not active, add "active" class
      if(!frd_my_store_dropdown.classList.contains('active')) {
        frd_my_store_dropdown.classList.add('active');

        return;
      }

      // If dropdown is active, remove "active" class
      if(frd_my_store_dropdown.classList.contains('active')) {
        frd_my_store_dropdown.classList.remove('active');

        return;
      }
    });

    // Outside click listener (closes dropdown if active and click is outside)
    document.addEventListener('click', (event) => {
      const frd_my_store_dropdown = document.querySelector('div[frd-my-store-header-dropdown]');
      const isClickInsideDropdown = frd_my_store_dropdown && frd_my_store_dropdown.contains(event.target);
      const isClickOnAnchor = frd_my_store_dropdown_anchor.contains(event.target);

      if (frd_my_store_dropdown && frd_my_store_dropdown.classList.contains('active') && !isClickInsideDropdown && !isClickOnAnchor) {
        frd_my_store_dropdown.classList.remove('active');
      }
    });
  },
  

  /**
   * Lightbox toggle
   */
  lightbox_toggle() {
    const frd_my_store_lightbox_anchors = document.querySelectorAll('button[frd-stores-lightbox]');
    let frd_my_store_overlay = document.querySelector('div[frd-stores-overlay]');
    let frd_my_store_lightbox = document.querySelector('div[frd-stores-lightbox]');
    let frd_my_store_lightbox_content = document.querySelector('div[frd-stores-lightbox-content]');
    let frd_stores_lightbox_close_button = document.querySelector('button[frd-stores-lightbox-close]');
    const frd_stores_search_form = document.querySelector('form[name="frd-stores-search"]');
    let search_miles_input = frd_stores_search_form.querySelector('input[name="miles"]');
    let search_postal_code_input = frd_stores_search_form.querySelector('input[name="postal-code"]');
    let search_button = frd_stores_search_form.querySelector('button[name="search"]');

    // If frd_my_store_lightbox_anchors does not exist
    if(!frd_my_store_lightbox_anchors) {
      return;
    }

    // Loop frd_my_store_lightbox_anchors
    frd_my_store_lightbox_anchors.forEach(frd_my_store_lightbox_anchor => {
      // Lightbox anchor click listener
      frd_my_store_lightbox_anchor.addEventListener('click', async (event) => {
        const search_form = document.querySelector('form[name="frd-stores-search"]');
        frd_my_store_overlay = document.querySelector('div[frd-stores-overlay]');
        frd_my_store_lightbox = document.querySelector('div[frd-stores-lightbox]');
        const product_id = Number(frd_my_store_lightbox_anchor.getAttribute('frd-product-id'));
        const variant_id = Number(frd_my_store_lightbox_anchor.getAttribute('frd-variant-id'));

        // If all stores, show search form
        if(!variant_id) {
          search_form.style.display = 'block';
        }

        // If variant stores, hide search form
        if(variant_id) {
          search_form.style.display = 'none';
        }

        // If lightbox is not active, add "active" class
        if(!frd_my_store_lightbox.classList.contains('active')) {
          // Clear old markup
          frd_my_store_lightbox.querySelector('div[frd-stores-lightbox-content]').innerHTML = '';

          // Add new markup
          frd_my_store_lightbox_content.insertAdjacentHTML('afterbegin', await FRDStores.get_stores_markup(product_id, variant_id));

          // Set store button click listeners
          FRDStores.set_store();

          // Add class
          frd_my_store_overlay.classList.add('active');
          frd_my_store_lightbox.classList.add('active');

          return;
        }

        // If lightbox is active, remove "active" class
        if(frd_my_store_lightbox.classList.contains('active')) {
          frd_my_store_overlay.classList.remove('active');
          frd_my_store_lightbox.classList.remove('active');

          return;
        }
      });
    });

    // Searh form submit listener
    frd_stores_search_form.addEventListener('submit', async (event) => {
      event.preventDefault();

      let search_miles = Number(frd_stores_search_form.querySelector('input[name="miles"]').value);
      let search_postal_code = frd_stores_search_form.querySelector('input[name="postal-code"]').value;
    
      // If user entered "miles" and "postal code"
      if(search_miles && search_postal_code) {
        const user_coordinatesx = await FRDStores.get_coordinates(search_postal_code);
        const user_latitude = user_coordinatesx.results[0].geometry.location.lat;
        const user_longitude = user_coordinatesx.results[0].geometry.location.lng;
        const stores_by_distance = await FRDStores.get_stores_by_distance(user_latitude, user_longitude, search_miles);
        const frd_my_store_lightbox = document.querySelector('div[frd-stores-lightbox]');
        const frd_my_store_lightbox_content = document.querySelector('div[frd-stores-lightbox-content]');

        // If stores by distances returns no results
        if(stores_by_distance.length === 0) {
          frd_my_store_lightbox.querySelector('div[frd-stores-lightbox-content]').innerHTML = `
            <p class="no-results">
              There are no stores within <i>${search_miles}</i> miles of <i>${search_postal_code}</i>.
            </p>
          `;
        }

        // If stores by distance returns results
        if(stores_by_distance.length > 0) {
          // Update lightbox stores list
          // Clear old markup
          frd_my_store_lightbox.querySelector('div[frd-stores-lightbox-content]').innerHTML = '';

          // Add new markup
          frd_my_store_lightbox_content.insertAdjacentHTML('afterbegin', await FRDStores.get_stores_markup(null, null, true, stores_by_distance));

          // Set store button click listeners
          FRDStores.set_store();
        }
      }
    });

    // Overlay click listener
    frd_my_store_overlay.addEventListener('click', (event) => {
      let clicked = event.target;
      let clicked_attributes = clicked.attributes;
      let clicked_attribute_name = null;

      // If clicked element has attributes
      if(clicked_attributes.length > 0) {
        clicked_attribute_name = clicked_attributes[0].name;
      }

      // If clicked element is overlay
      if(clicked_attribute_name === 'frd-stores-overlay') {
        frd_my_store_overlay.classList.remove('active');
        frd_my_store_lightbox.classList.remove('active');

        // Clear input fields
        search_miles_input.value = '';
        search_postal_code_input.value = '';
      }
    });

    // Close button click listener
    frd_stores_lightbox_close_button.addEventListener('click', (event) => {
      frd_my_store_overlay.classList.remove('active');
      frd_my_store_lightbox.classList.remove('active');

      // Clear input fields
      search_miles_input.value = '';
      search_postal_code_input.value = '';
    });
  },

  /**
   * Get stores
   */
  async get_stores(product_id = null, variant_id = null) {
    let stores = frd_stores['stores'];

    // If variant ID
    if(variant_id) {
      //TODO: use the passed variable
      const product_id = Number(document.querySelector('[frd-product-id]').getAttribute('frd-product-id'));

      // Update stores to be stores with this variant
      stores = await frd_get_variant_stores(product_id, variant_id);

      // String to object
      stores = JSON.parse(stores);
    }

    // Sort alphabetically by title
    stores.sort(function (a, b) {
      if(a.title < b.title) {
        return -1;
      }

      if(a.title > b.title) {
        return 1;
      }
      
      return 0;
    });

    // Return
    return stores;
  },

  /**
   * Get stores by distance
   */
  async get_stores_by_distance(user_latitude = null, user_longitude = null, miles = null, product_id = null) {
    // Set stores using assign so we don't update the referenced object
    let stores = Object.assign([], await FRDStores.get_stores());

    // Map stores
    let stores_by_distance = await Promise.all(stores.map(async (store) => {
      // Set new store using assign so we don't update the referenced object
      let new_store = Object.assign({}, store);
      
      // Add "distance" to new store
      let distance = await FRDStores.get_distance_between(store.id, user_latitude, user_longitude);

      new_store.distance = distance;

      // return store
      return new_store;
    }));

    // Filter stores by distance
    stores_by_distance = stores_by_distance.filter(function(store) {
      return store.distance <= miles;
    });

    // Sort stores by distance
    stores_by_distance.sort(function(a, b) {
      return a.distance - b.distance;
    });

    // Return
    return stores_by_distance;
  },

  /**
   * Get stores markup
   */
  async get_stores_markup(product_id = null, variant_id = null, re_render = false, re_render_stores = null,) {
    const my_mho_store_id = localStorage.getItem('my_mho_store_id');
    const global_settings = frd_stores['global_settings'];
    let stores = await FRDStores.get_stores();

    // If variant ID
    if(variant_id) {
      // Update stores to be stores with this variant
      stores = await FRDStores.get_stores(product_id, variant_id);

      // String to object
      //stores = JSON.parse(stores);
    }

    // If re render, use passed stores
    if(re_render === true) {
      stores = re_render_stores;
    }

    // Sort alphabetically by title
    stores.sort(function (a, b) {
      if(a.title < b.title) {
        return -1;
      }

      if(a.title > b.title) {
        return 1;
      }
      
      return 0;
    });

    let stores_markup = '';

    // Loop stores
    for(let store of stores) {
      // Get store
      const store_info = await FRDStores.get_store(store.id);

      // Merge store info and store inventory
      store.title = store_info.title;
      store.address = store_info.address;
      store.email = store_info.email;
      store.phone = store_info.phone;
      store.url = store_info.url;
      store.delivery_method_settings = store_info.delivery_method_settings;
      store.latitude = store_info.latitude;
      store.longitude = store_info.longitude;

      // Create store list item
      const store_component = FRDStores.store_component(store, 'lightbox');
      
      stores_markup += `<li frd-stores-list-item>
        ${store_component}
      </li>`;
    }

    // Return
    return `<ul frd-stores-list>${stores_markup}</ul>`;
  },

  /**
   * Get store
   */
  async get_store(store_id = null) {
    // If store_id does not exist
    if(!store_id) {
      //console.log('Missing "store_id" parameter.');

      return;
    }

    // Filter stores
    const stores = await FRDStores.get_stores();
    const store = stores.filter(function(store) {
      return store.id == store_id;
    });
    
    // Return
    return store[0];
  },

  /**
   * Set store
   */
  async set_store() {
    let my_store_button = document.querySelector('button[frd-my-store-id]');
    const set_store_buttons = document.querySelectorAll('button[frd-set-store-id]');
    const frd_my_store_dropdown = document.querySelector('div[frd-my-store-header-dropdown] div:first-child');
    const delivery_methods_section = document.querySelector('section[frd-delivery-methods]');

    // If store is set
    if(!my_store_button) {
      // Use Choose a Store button
      my_store_button = document.querySelector('button[frd-stores-lightbox]');
    }

    // Loop set store buttons
    set_store_buttons.forEach(set_store_button => {
      // Set store button click listener
      set_store_button.addEventListener('click', async (event) => {
        let active_set_store_button = document.querySelector('button[frd-set-store-id].active');
        let set_store_id = set_store_button.getAttribute('frd-set-store-id');
        let set_store_title = set_store_button.parentElement.parentElement.querySelector('span.title').textContent;
        let store = await FRDStores.get_store(set_store_id);
        let store_component = FRDStores.store_component(store, 'header', true);
        let pickup_input = document.querySelector('input[name="properties[Shipping]"]');
        let pickup_location_input = document.querySelector('input[name="properties[Location]"]');
        const delivery_selected = document.querySelector('button[frd-delivery-tab].active');

        // Save store ID to local storage
        localStorage.setItem('my_mho_store_id', set_store_id);

        // If an active Set Store button exists
        if(active_set_store_button) {
          // Remove "active" class from current store button
          active_set_store_button.classList.remove('active');

          // Update text of current store button
          active_set_store_button.innerHTML = '<span class="icon-star">&#9734;</span> Set as my store';

          // Remove disabled to clicked store button
          active_set_store_button.removeAttribute('disabled');
          active_set_store_button.removeAttribute('aria-disabled');
        }
        
        // Add "active" class to clicked store button
        set_store_button.classList.add('active');

        // Update text of clicked store button
        set_store_button.innerHTML = '<span class="icon-star">&#9733;</span> My store';

        // Add disabled to clicked store button
        set_store_button.setAttribute('disabled', true);
        set_store_button.setAttribute('aria-disabled', true);

        // Update header
        // my_store_button.setAttribute('frd-my-store-id', set_store_id);
        // my_store_button.textContent = set_store_title;
          my_store_button.removeAttribute('frd-stores-lightbox');

        // Full location in attribute
        my_store_button.setAttribute('frd-my-store-id', store.address);

        // Short code as visible text
        my_store_button.textContent = store.id; // or custom short name


        //TODO: set_store() store_component: fix my_store_button no triggering dropdown immediately after setting store

        // If dropdown exists
        if(frd_my_store_dropdown) {
          // Update dropdown
          frd_my_store_dropdown.innerHTML = '';
          frd_my_store_dropdown.insertAdjacentHTML('afterbegin', store_component);
        }

        // If product page
        if(add_to_cart_button_selector) {
          // Set store block
          let selected_store = await frd_default_store_block();

          // Quantity check
          frd_quantity_check();

          // If property input does not exist
          if(!pickup_input) {
            // Insert element
            delivery_methods_section.insertAdjacentHTML('afterbegin', 
              `<input id="pickup" name="properties[Shipping]" type="hidden" value="Pick Up In-Store at ${store.title}">
              <input id="pickup-location" name="properties[Location]" type="hidden" value="${store.id}">`
            );
          }

          // If property input exits and delivery is selected
          if(pickup_input && delivery_selected === null) {
            // Update value
            pickup_input.value = `Pick Up In-Store at ${store.title}`;
            pickup_location_input.value = store.id;
          }
        }
      });
    });
  },

  /**
   * Get global settings
   */
  get_global_settings() {
    const global_settings = frd_stores['global_settings'];

    // Return
    return global_settings;
  },

  /**
   * Get store settings
   */
  async get_store_settings(store_id = null) {
    // If store_id does not exist
    if(!store_id) {
      //console.log('Missing "store_id" parameter.');

      return;
    }

    // Filter stores
    const stores = await FRDStores.get_stores();
    const store = stores.filter(function(store) {
      return store.id == store_id;
    });

    // Return
    return store[0].delivery_method_settings;
  },
  
  /**
   * Get distance between user and store
   */
  async get_distance_between(store_id, user_latitude, user_longitude) {
    const store = await FRDStores.get_store(store_id);

    // If store does not exist
    if(!store) {
      //console.log('Missing "store" parameter.');

      return;
    }

    const store_latitude = store.latitude;
    const store_longitude = store.longitude;
  
    if(user_latitude === store_latitude && user_longitude === store_longitude) {
      return 0;
    }
  
    let radlat1 = Math.PI * user_latitude / 180;
    let radlat2 = Math.PI * store_latitude / 180;
    let theta = user_longitude - store_longitude;
    let radtheta = Math.PI * theta / 180;
    let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  
    if(dist > 1) {
      dist = 1;
    }
  
    dist = Math.acos(dist);
    dist = dist * 180 / Math.PI;
    dist = dist * 60 * 1.1515;
  
    return dist;
  },

  /**
   * Get coordinates
   * @param {*} postal_code
   */
  async get_coordinates(postal_code) {
    const google_api_key = 'AIzaSyC0loMynFaT9vx0o9unZm1L0W9bjra4BNI';
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${postal_code},US&key=${google_api_key}`;

    try {
      let response = await fetch(url);

      return await response.json();
    } catch (error) {
      console.log(error);
    }
  },

  /**
   * Geolocation: get permissions
   * @returns 
   * !//TODO: geolocation_get_permissions()!
   */
  geolocation_get_permissions() {
    // If browser does not support geolocation
    if(!navigator.geolocation) {
      return;
    }

    // Check navigator permissions for geolocation
    navigator.permissions.query({ name: 'geolocation' }).then(function(response) {
      // Permission granted
      if(response.state === 'granted') {
        console.log('geolocation_get_permissions() granted');
      }

      // Permission denied
      if(response.state === 'denied') {
        console.log('geolocation_get_permissions() denied');
      }
    });
  },

  /**
   * Geolocation: get position
   * @returns 
   */
  geolocation_get_position() {
    // If browser does not support geolocation
    if(!navigator.geolocation) {
      return;
    }

    // Get position
    navigator.geolocation.getCurrentPosition(
      FRDStores.geolocation_success,
      FRDStores.geolocation_error,
      {
        timeout: 5000
      }
    );
  },

  /**
   * Geolocation: success
   * @param {*} position 
   */
  async geolocation_success(position) {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    const stores_by_distance = await FRDStores.get_stores_by_distance(latitude, longitude, 50);
    let my_store_button = document.querySelector('button[frd-my-store-id]');
    const frd_my_store_dropdown = document.querySelector('div[frd-my-store-header-dropdown] div:first-child');
    const pickup_input = document.querySelector('input[name="properties[Shipping]"]');
    const pickup_location_input = document.querySelector('input[name="properties[Location]"]');
    const delivery_methods_section = document.querySelector('section[frd-delivery-methods]');
    const delivery_selected = document.querySelector('button[frd-delivery-tab].active');

    // If store is set
    if(!my_store_button) {
      // Use Choose a Store button
      my_store_button = document.querySelector('button[frd-stores-lightbox]');
    }

    // Save coordinates to local storage
    localStorage.setItem('my_mho_coords', `${latitude}|${longitude}`);

    // If there is a store within 50 miles of user
    if(stores_by_distance.length > 0) {
      // Get closest store
      const closest_store = stores_by_distance[0];
      const closest_store_id = closest_store.id;
      const closest_store_title = closest_store.title;

      // Get store component
      const store_component = FRDStores.store_component(closest_store, 'header', true);

      // Save store ID to local storage
      localStorage.setItem('my_mho_store_id', closest_store_id);

      //TODO: geolocation_success() make all these updates into a single function for DRY pattern. set_store() uses all of these updates.
      // Update header
      my_store_button.setAttribute('frd-my-store-id', closest_store_id);
      my_store_button.removeAttribute('frd-stores-lightbox');
      my_store_button.textContent = closest_store_title;

      //TODO: geolocation_success() store_component: fix my_store_button no triggering dropdown immediately after setting store

      // If dropdown exists
      if(frd_my_store_dropdown) {
        // Update dropdown
        frd_my_store_dropdown.innerHTML = '';
        frd_my_store_dropdown.insertAdjacentHTML('afterbegin', store_component);
      }

      // If product page
      if(add_to_cart_button_selector) {
        // Set store block
        let selected_store = await frd_default_store_block();

        // Quantity check
        frd_quantity_check();

        // If property input does not exist
        if(!pickup_input) {
          // Insert element
          delivery_methods_section.insertAdjacentHTML('afterbegin', 
            `<input id="pickup" name="properties[Shipping]" type="hidden" value="Pick Up In-Store at ${closest_store_title}">
            <input id="pickup" name="properties[Location]" type="hidden" value="${closest_store_id}">`
          );
        }

        // If property input exits and delivery is selected
        if(pickup_input && delivery_selected === null) {
          // Update value
          pickup_input.value = `Pick Up In-Store at ${closest_store_title}`;
          pickup_location_input.value = closest_store_id;
        }
      }
    }
  },

  /**
   * Geolocation: error
   */
  geolocation_error() {
    // Remove coordinates from local storage
    localStorage.removeItem('my_mho_coords');
  }
};

FRDStores.ready();

document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('div[frd-my-store-header]');
  if (!header) return;

  const svgIcon = header.querySelector('svg');
  const button = header.querySelector('button[frd-stores-lightbox], button[frd-my-store-id]');

  if (svgIcon && button) {
    svgIcon.style.cursor = 'pointer';
    svgIcon.addEventListener('click', function (event) {
      event.stopPropagation(); 
      button.click(); 
    });
  }
});


